<template>
	<div class="hos-district">
		<div class='multi-hospital'>
			<div class="apply-title-center2">
				<div class="title_left">
					<img class="hos-logo multi-hos_logo" :src="hospitalParam.hosLogoUrl" />
					<div class="title multi-hos_title">{{hosName}}</div>
				</div>
				<router-link class="title_right" to="/hos-list">
					<div class='selHos'>选择医院</div>
				</router-link>
			</div>
			<div class='apply-title-center'>
				<div class='hos_warn'>{{hospitalParam.desc}}</div>
			</div>
			<div class="weui-cells__title">申请院区</div>
			<div class="multi-hos" v-for="(item,index) in itemsDis" :key="'hos'+index" @click="selectHos(item.hosId)">
				<div class='multi-hospital-cell'>
					<div class='logo_cell'>
						<img class='logo_content' :src='item.hosLogoUrl' />
					</div>
					<div class='multi-hos_content'>
						<div class="multi-hos_title">{{item.hosName}}</div>

						<div class='hos_item_type'>
							<div v-for="(item,index) in item.hBusinessLevelTwo" :key="'type1'+index">
								<div class='expressType2'>{{item.name}}</div>
							</div>
							<div v-for="(item,index) in item.hBusinessLevelThree" :key="'type2'+index">
								<div class='expressType1'>{{item.name}}</div>
							</div>
							<!-- <view class='expressType2'>门诊病例</view> -->
						</div>
						<div class='multi-hos_address'>
							<img class="address_logo" src='../assets/address.svg' />
							<div class='hos_item_address'>{{item.hosAddr}}</div>
						</div>
					</div>

				</div>
				<div class='zhushi'>
					<span class='text_head'>注:</span>申请需要输入住院号、入院时间、出院时间、患者姓名、证件号、手机号等。
				</div>
			</div>

		</div>
	</div>

</template>

<script>
	import {
		mapState,mapGetters
	} from 'vuex'
	export default {
		name: 'hosDistrict',
		data() {
			return {}
		},
		created() {
			let wxId = localStorage.getItem('wxId');
			let hosId = this.$route.params.hosId;
			const params = {
				wxId: wxId,
				hosId: hosId
			}
			// this.getHosDistrict(params)
			this.$store.dispatch('getHosDistrict', params);
			// this.reload();
		},
		computed: {
			...mapState({
				hosName: state => state.district.hosName,
				hospitalParam: state => state.district.hospitalParam,
				result: state =>state.district.result
			}),
			...mapGetters([
				'itemsDis'
			])
		},
		methods: {
			selectHos(e) {
				localStorage.setItem('hosId',e)
				// this.$router.push('/apply' + '?hosId=' + e)
				this.$router.push('/apply/' + e + '/' + '-1')
			}
		}

	}
</script>

<style>
	/* 多院区列表布局 */

	.multi-hos {
		margin-bottom: 10px;
	}

	.multi-hospital-cell {
		display: flex;
		display: -webkit-flex;
		/* Safari */
		background: #fff;
		position: relative;
	}

	.multi-hospital-cell::after {
		content: " ";
		position: absolute;
		left: 15px;
		bottom: 0;
		right: 15px;
		height: 1px;
		border-bottom: 1px solid #d9d9d9;
		color: #d9d9d9;
	}

	.logo_cell {
		margin: auto 0;
	}

	.logo_content {
		position: relative;
		width: 2.48rem;
		height: 2.48rem;
		margin: 20px;
		display: inline-block;
		align-self: center;
	}

	.multi-hos_content {
		display: flex;
		display: -webkit-flex;
		/* Safari */
		flex-direction: column;
		padding: 10px 0;
	}

	.multi-hos_title {
		font-size: 16px;
		color: #333;
		font-weight: bold;
	}

	.hos_item_type {
		display: flex;
		display: -webkit-flex;
		/* Safari */
		margin-top: 5px;
		margin-left: -5px;
		flex-wrap: wrap;
	}

	.multi-hos_address {
		display: flex;
		margin-top: 5px;
	}

	.hos_item_address {
		font-size: 15px;
	}

	.address_logo {
		display: inline-block;
		align-self: center;
		width: 15px;
		height: 15px;
	}

	.hos_zhushi {
		font-size: 14px;
		color: #999;
	}

	.zhushi {
		padding: 10px 15px;
		font-size: 14px;
		color: #999;
		background: #fff;
	}

	.multi-hos_tips {
		background: #effbff;
		display: flex;
		display: -webkit-flex;
		/* Safari */
		padding: 10px;
	}

	.multi-hos_tips_content {
		color: #333;
		font-size: 15px;
	}

	.select_hos {
		color: #1aac19;
		font-size: 15px;
		font-weight: bold;
	}

	.multi-hospital {
		margin-bottom: 20px;
		background: #efeff4;
		position: relative;
		z-index: 4;
	}

	.multi-hos_logo {
		width: 2.48rem;
		height: 2.48rem;
		margin: 5px;
	}

	.multi-hos_title {
		font-size: 16px;
		font-weight: bold;
	}

	.navigator-hover {
		background-color: #e5e5e5;
	}

	.hos_warn {
		color: red;
		font-size: 15px;
		margin: auto;
	}

	.apply-title-center2 {
		background-color: white;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		flex-direction: row;
		-webkit-flex-direction: row;
		justify-content: space-between;
		-webkit-justify-content: space-between;
		/* height: 50px; */
		position: relative;
	}

	.apply-title-center2::after {
		content: " ";
		position: absolute;
		left: 15px;
		bottom: 0;
		right: 15px;
		height: 1px;
		border-bottom: 1px solid #d9d9d9;
		color: #d9d9d9;
	}

	.ann {
		font-size: 12px;
		text-align: center;
		color: #1aac19;
		padding-left: 2px;
		padding-right: 2px;
		border: 1px solid #1aac19;
		white-space: nowrap;
		margin-right: 10px;
	}

	.selHos {
		color: #1aac19;
		padding-left: 5px;
		padding-right: 5px;
		margin-right: 10px;
	}

	.selHos::after {
		content: " ";
		display: inline-block;
		height: 6px;
		width: 6px;
		border-width: 2px 2px 0 0;
		border-color: #1aac19;
		border-style: solid;
		-webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position: relative;
		/* top: -2px; */
		/* position: absolute;*/
		top: 50%;
		/* right: 5px; */
		margin-top: -4px;
	}

	.btn-hover {
		color: rgba(255, 255, 255, 0.6);
		background-color: #179b16;
	}

	.expressType2 {
		border: 1px solid #FF8605;
		color: #FF8605;
		font-size: 10px;
		width: auto;
		height: auto;
		line-height: 1.5;
		text-align: center;
		margin-left: 5px;
		border-radius: 3px;
		padding-left: 3px;
		padding-right: 3px;
		margin: 5px;
	}

	.expressType1 {
		border: 1px solid #007DE4;
		color: #007DE4;
		font-size: 10px;
		width: auto;
		height: auto;
		line-height: 1.5;
		text-align: center;
		margin-left: 5px;
		border-radius: 3px;
		padding-left: 3px;
		padding-right: 3px;
		margin: 5px;
	}

	.title_left {
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		margin-left: 10px;
	}

	.apply-title-center {
		background-color: white;
		border-bottom: 1px solid #ddd;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		flex-direction: row;
		-webkit-flex-direction: row;
		justify-content: space-between;
		-webkit-justify-content: space-between;
		height: fit-content;
	}
</style>
